import { PredominantDegree } from '@backrs_ui/common-ui';

type CollegeSize = 'Very Small' | 'Small' | 'Medium' | 'Large';

export const determineCollegeSize = (undergradEnrollment?: number): CollegeSize => {
  if (!undergradEnrollment) {
    return 'Very Small';
  }

  switch (true) {
    case undergradEnrollment > 20000:
      return 'Large';
    case undergradEnrollment > 5000:
      return 'Medium';
    case undergradEnrollment > 2000:
      return 'Small';
    default:
      return 'Very Small';
  }
};

export const determineDegreeType = (predominantDegree?: PredominantDegree): '4 year' | '2 year' => {
  if (!predominantDegree) {
    return '4 year';
  }

  if (predominantDegree === "Predominantly bachelor's-degree granting") {
    return '4 year';
  }

  return '2 year';
};

export const RIGOR_LEVELS = [
  'Less Important',
  'Important',
  'Very Important',
  'Critically Important',
] as const;

export const EXTRACURRICULAR_LEVELS = [
  'Weak',
  'Typical',
  'Strong',
  'Very Strong',
  'Exceptional',
] as const;

export const SELECTIVITY_LEVELS = ['Not Very', 'Somewhat', 'Highly'] as const;

export const getRigorLabel = (rigorLevel: number): string => RIGOR_LEVELS[rigorLevel] ?? 'N/A';

export const getExtracurricularsLabel = (extracurricularsLevel: number): string =>
  EXTRACURRICULAR_LEVELS[extracurricularsLevel] ?? 'N/A';

export const getSelectivityLabel = (selectivityLevel: number): string =>
  SELECTIVITY_LEVELS[selectivityLevel - 1] ?? 'N/A';
